import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <title>404 - Page Not Found</title>
                <meta name="description" content="The page you are looking for does not exist." />
            </Helmet>
            <div className="w-[100%] h-[100vh] flex flex-col items-center justify-center bg-[#fff9e7]">
                <img
                    src="https://storage.googleapis.com/meshkey_cms/plant_finder/404.png"
                    alt="Page not found"
                />
                <Link to="/" className="back-home-link">Back to Home</Link>
            </div>
        </HelmetProvider>
    );
};

export default NotFoundPage;